"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeAndZone = void 0;
const tslib_1 = require("tslib");
const dayjs_1 = (0, tslib_1.__importDefault)(require("dayjs"));
const designed_1 = require("designed");
const class_validator_1 = require("class-validator");
const utc_1 = (0, tslib_1.__importDefault)(require("dayjs/plugin/utc"));
const timezone_1 = (0, tslib_1.__importDefault)(require("dayjs/plugin/timezone"));
const advancedFormat_1 = (0, tslib_1.__importDefault)(require("dayjs/plugin/advancedFormat"));
const ResponseBase_1 = require("../../ResponseBase");
const AbsoluteDate_1 = require("./AbsoluteDate");
const TimeAndDate_1 = require("./TimeAndDate");
dayjs_1.default.extend(timezone_1.default);
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(advancedFormat_1.default);
class TimeAndZone extends ResponseBase_1.ResponseBase {
    /**
     * Ignores UTC timezone and returns the default
     */
    static getTimezone() {
        const guess = dayjs_1.default.tz.guess();
        return guess === 'UTC'
            ? TimeAndZone.DEFAULT_TZ
            : guess || TimeAndZone.DEFAULT_TZ;
    }
    static nowForCurrentProcess() {
        return TimeAndZone.create({
            time: TimeAndDate_1.TimeAndDate.present(),
            zone: TimeAndZone.getTimezone(),
        });
    }
    static nowForZone(zone) {
        return TimeAndZone.create({
            time: TimeAndDate_1.TimeAndDate.present(),
            zone,
        });
    }
    getParsed() {
        return dayjs_1.default.tz(this.time, this.zone);
    }
    toDate() {
        const parsed = dayjs_1.default.tz(this.time, this.zone);
        return AbsoluteDate_1.AbsoluteDate.create({
            day: parsed.date(),
            month: parsed.month() + 1,
            year: parsed.year(),
        });
    }
    toFormat(format) {
        return this.getParsed().format(TimeAndZone.FORMATS[format].format);
    }
}
TimeAndZone.DEFAULT_TZ = 'Australia/Sydney';
TimeAndZone.FORMATS = {
    userFacingDate: {
        format: 'DD/MM/YYYY',
        example: '01/01/2022',
    },
    userFacingDateTime: {
        format: 'DD/MM/YYYY hh:mm a',
        example: '01/01/2022 12:00 am',
    },
    fullDate: {
        format: 'dddd, MMMM Do YYYY',
        example: 'Monday, January 1st 2022',
    },
    fullDateTime: {
        format: 'dddd, MMMM Do YYYY hh:mm a',
        example: 'Monday, January 1st 2022 12:00 am',
    },
    fullDateWithZone: {
        format: 'dddd, MMMM Do YYYY [in] z',
        example: 'Monday, January 1st 2022 in GMT+11',
    },
    fullDateTimeWithZone: {
        format: 'dddd, MMMM Do YYYY hh:mm a [in] z',
        example: 'Monday, January 1st 2022 12:00 am in GMT+11',
    },
    shortDate: {
        format: 'DD MMM YYYY',
        example: '01 Jan 2023',
    },
    shortDateTime: {
        format: 'DD MMM YYYY hh:mm a',
        example: '01 Jan 2023 12:00 am',
    },
    shortDateTimeWithZone: {
        format: 'DD MMM YYYY hh:mm a [in] z',
        example: '01 Jan 2023 12:00 am in GMT+11',
    },
};
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsString)(),
    (0, tslib_1.__metadata)("design:type", String)
], TimeAndZone.prototype, "zone", void 0);
(0, tslib_1.__decorate)([
    designed_1.Entity.Field({ entity: TimeAndDate_1.TimeAndDate }),
    (0, class_validator_1.IsInstance)(TimeAndDate_1.TimeAndDate),
    (0, tslib_1.__metadata)("design:type", TimeAndDate_1.TimeAndDate)
], TimeAndZone.prototype, "time", void 0);
(0, tslib_1.__decorate)([
    designed_1.Memoize.All(),
    (0, tslib_1.__metadata)("design:type", Function),
    (0, tslib_1.__metadata)("design:paramtypes", []),
    (0, tslib_1.__metadata)("design:returntype", void 0)
], TimeAndZone.prototype, "getParsed", null);
exports.TimeAndZone = TimeAndZone;
